import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/loading.gif")